import React, { ReactNode, useContext, useEffect, useState } from 'react';

import BuildingKeysContext from '@totem/components/portfolio/buildings/details/keys/BuildingKeysContext';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { ForeignKey } from '@totem/types/common';
import { BUILDINGS_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  buildingId: string;
  children?: ReactNode;
};

const BuildingKeysContainer = ({ buildingId, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<ForeignKey[]>([]);
  const [refresh, setRefresh] = useState<boolean>(true);

  useEffect(() => {
    setRefresh(true);
  }, [buildingId]);

  useEffect(() => {
    if (!refresh) {
      return;
    }

    setRefresh(false);

    setLoading(true);

    fetch(`${BUILDINGS_ENDPOINT}/${buildingId}/keys`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: ForeignKey[]) => {
        setData(Array.isArray(result) ? result : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [refresh, buildingId, getApiToken]);

  return (
    <BuildingKeysContext.Provider
      value={{
        loading,
        data,
        buildingId,
        requestRefresh: () => setRefresh(true),
      }}
    >
      {children}
    </BuildingKeysContext.Provider>
  );
};

export default BuildingKeysContainer;
